const baseStyle = {
    color: 'link',
};

export default {
    baseStyle,
}